export const summerTitleConvertorBasedOnComponentName = (title: string) => {
    switch (title) {
        case 'بنر متوسط ضدآفتاب':
            return 'آفتاب دوست‌داشتنی'
        case 'بنر متوسط شوینده و آبرسان':
            return 'نرم و مرطوب'
        case 'بنر متوسط آرایشی':
            return 'شاد و رنگی'
        case 'بنر متوسط اکسسوری + مکمل':
            return 'همراه کاربردی'
        case 'بنر متوسط سکشن عطرو ...':
            return 'رایحه ماندنی'
        default:
            return title
    }
}
